import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit {

  @Input() profileSearchResults: ProfileSearchResult[];
  @Output() cardholderSelected: EventEmitter<ProfileSearchResult> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  selectCardholder(cardholder: ProfileSearchResult) {
    this.cardholderSelected.emit(cardholder);
  }

}
